import { fetcher } from "helpers/fetcher";

import {
  TDeleteOrganizationImageReq,
  TDeleteOrganizationImageRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const deleteOrganizationImageExterior = async (
  payload: TDeleteOrganizationImageReq
) => {
  return await fetcher<
    TDeleteOrganizationImageRes,
    TDeleteOrganizationImageReq["data"]
  >(ENDPOINT.CORPORATION.DELETE_ORGANIZATION_IMAGE_EXTERIOR, {
    data: payload.data,
    headers: {
      [API_HEADER.CORP_ID]: payload.idCorp,
      [API_HEADER.VERSION]:
        ENDPOINT.CORPORATION.DELETE_ORGANIZATION_IMAGE_EXTERIOR.version,
    },
  });
};

export const mutationDeleteOrganizationImageExterior = async (
  payload: TDeleteOrganizationImageReq
) => {
  return (await deleteOrganizationImageExterior(payload)).data.message;
};

mutationDeleteOrganizationImageExterior._key = (
  payload: TDeleteOrganizationImageReq
) => [ENDPOINT.CORPORATION.DELETE_ORGANIZATION_IMAGE_EXTERIOR.url, payload];
